import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

import {
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "./MarketingSection";

export type FaqItem = { question: string; answer: ReactNode };

type FaqSectionProps = {
  items: FaqItem[];
  title?: string;
  /** Shows the "Questions" kicker above the title. */
  kicker?: boolean;
  className?: string;
};

export default function FaqSection({
  items,
  title = "Everything you need to know.",
  kicker = true,
  className,
}: FaqSectionProps) {
  return (
    <MarketingSection className={cn("bg-[#F7F8FB]", className)}>
      {kicker && <SectionKicker>Questions</SectionKicker>}
      <SectionTitle>{title}</SectionTitle>
      <div className="mt-[45px] grid grid-cols-2 items-start gap-x-[22px] gap-y-[15px] max-[680px]:grid-cols-1">
        {items.map((item) => (
          <details
            key={item.question}
            className="group overflow-hidden rounded-[16px] border border-marketing-line bg-white"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-[22px] py-5 font-open-sans text-[16px] font-extrabold after:text-[22px] after:font-normal after:text-blue-600 after:content-['+'] group-open:after:content-['−'] [&::-webkit-details-marker]:hidden">
              {item.question}
            </summary>
            <p className="m-0 px-[22px] pb-[22px] font-open-sans text-[16px] leading-[1.55] text-marketing-muted [&_a]:font-extrabold [&_a]:text-blue-600 [&_a]:underline [&_a]:underline-offset-[3px]">
              {item.answer}
            </p>
          </details>
        ))}
      </div>
    </MarketingSection>
  );
}
